import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-domain-scan-internal-urls',
    templateUrl: './form-domain-scan-internal-urls.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false,
})
export class FormDomainScanInternalUrlsComponent implements OnInit {
    @Input() internalUrls: any[] = [];
    @Output() internalUrlsChange = new EventEmitter<any[]>();

    operators: any[] = [];

    constructor (private translateService: TranslateService) {}

    ngOnInit () {
        if (this.internalUrls.length === 0) {
            this.addUrl();
        }
        this.setupOperators();
    }

    setupOperators () {
        this.operators = [
            {
                value: 'contains',
                name: this.translateService.getString('Contains'),
            },
            {
                value: 'starts_with',
                name: this.translateService.getString('Starts with'),
            },
            {
                value: 'regex',
                name: this.translateService.getString('Regex'),
            },
        ];
    }

    addUrl (): void {
        this.internalUrls.push({ operator: 'starts_with' });
        this.internalUrlsChange.emit(this.internalUrls);
    }

    removeUrl (index: number): void {
        this.internalUrls.splice(index, 1);
        this.internalUrlsChange.emit(this.internalUrls);
    }

    onUrlChange (): void {
        this.internalUrlsChange.emit(this.internalUrls);
    }
}
